import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" keywords={[`ambrogi`, `software engineer`, `react`]} />
    <h1>Software engineer</h1>
    <p>👨‍💻 React, AWS, Node, testing, system architectures, mentoring, coaching and learning new things.</p>
    <script type="text/javascript" src="https://platform.linkedin.com/badges/js/profile.js" async defer></script>
    <div className="LI-profile-badge" data-version="v1" data-size="large" data-locale="it_IT" data-type="horizontal" data-theme="dark" data-vanity="giulio-ambrogi-b1969565">
      <a className="LI-simple-link" href='https://uk.linkedin.com/in/giulio-ambrogi-b1969565?trk=profile-badge'>Giulio Ambrogi</a>
    </div>
    <br />
    <ul>
      {/* <li><a href="https://www.linkedin.com/in/giulio-ambrogi-b1969565" target="_blank">LinkedIn</a></li> */}
      <li><a target="_blank" href="https://github.com/giulioambrogi">Github</a></li>
      {/* <li><a href="">Medium</a></li> */}
      <li><a target="_blank" href="https://twitter.com/GiulioAmbrogi">Twitter</a></li>
    </ul>
    <h3>Other things I like</h3>
    <p><a href="https://open.spotify.com/artist/3hUA7QM6tiEVY1R9PqWBsk" target="_blank">Music production</a>, football and sea places.</p>
    <hr />
  </Layout>
)

export default IndexPage
